import { IKycDocument, IKycDocumentPreview } from '../models';

import { TComputedKycDocument } from '@/features/kyc/store/models/kyc.model';

import { TAppError, IBaseAction, IBaseState } from '@/store/types/base.state';
import { IBaseModalProps } from '@/store/types/modals.types';
import { IState, ICursorElements } from '@/store/types/search.types';
import { IUser } from '@/features/user/store/user.model';

export enum KycActionTypes {
  GET_KYC_NEED_REVIEW_DOCUMENTS = 'KYC_NEED_REVIEW.GET_KYC_NEED_REVIEW',
  GET_KYC_NEED_REVIEW_DOCUMENTS_SUCCESS = 'KYC_NEED_REVIEW.GET_KYC_NEED_REVIEW_SUCCESS',
  GET_KYC_NEED_REVIEW_DOCUMENTS_FAIL = 'KYC_NEED_REVIEW.GET_KYC_NEED_REVIEW_FAIL',

  GET_KYC_NEED_REVIEW_DOCUMENT_PREVIEW = 'KYC_NEED_REVIEW.GET_KYC_NEED_REVIEW_DOCUMENT_PREVIEW',
  GET_KYC_NEED_REVIEW_DOCUMENT_PREVIEW_SUCCESS = 'KYC_NEED_REVIEW.GET_KYC_NEED_REVIEW_DOCUMENT_PREVIEW_SUCCESS',
  GET_KYC_NEED_REVIEW_DOCUMENT_PREVIEW_FAIL = 'KYC_NEED_REVIEW.GET_KYC_NEED_REVIEW_DOCUMENT_PREVIEW_FAIL',

  REVIEW_NEED_REVIEW_DOCUMENT = 'KYC_NEED_REVIEW.REVIEW_NEED_REVIEW_DOCUMENT',
  REVIEW_NEED_REVIEW_DOCUMENT_FAIL = 'KYC_NEED_REVIEW.REVIEW_NEED_REVIEW_DOCUMENT_FAIL',
  REVIEW_NEED_REVIEW_DOCUMENT_SUCCESS = 'KYC_NEED_REVIEW.REVIEW_NEED_REVIEW_DOCUMENT_SUCCESS',
}

export interface IGetKycNeedReviewAction extends IBaseAction {
  type: typeof KycActionTypes.GET_KYC_NEED_REVIEW_DOCUMENTS;
}

export interface IGetKycNeedReviewSuccessAction extends IBaseAction {
  type: typeof KycActionTypes.GET_KYC_NEED_REVIEW_DOCUMENTS_SUCCESS;
  needReviewDocuments: ICursorElements<IKycDocument>;
}

export interface IGetKycNeedReviewFailAction extends IBaseAction {
  type: typeof KycActionTypes.GET_KYC_NEED_REVIEW_DOCUMENTS_FAIL;
  error: TAppError;
}

export interface IGetKycNeedReviewPreviewAction extends IBaseAction {
  type: typeof KycActionTypes.GET_KYC_NEED_REVIEW_DOCUMENT_PREVIEW;
  documentId: string;
}

export interface IGetKycNeedReviewPreviewSuccessAction extends IBaseAction {
  type: typeof KycActionTypes.GET_KYC_NEED_REVIEW_DOCUMENT_PREVIEW_SUCCESS;
  documentId: string;
  preview: IKycDocumentPreview;
}

export interface IGetKycNeedReviewPreviewFailAction extends IBaseAction {
  type: typeof KycActionTypes.GET_KYC_NEED_REVIEW_DOCUMENT_PREVIEW_FAIL;
  documentId: string;
  error: TAppError;
}

export interface IReviewNeedReviewDocumentAction extends IBaseAction {
  type: typeof KycActionTypes.REVIEW_NEED_REVIEW_DOCUMENT;
  document: IKycDocument;
}

export interface IReviewNeedReviewDocumentSuccessAction extends IBaseAction {
  type: typeof KycActionTypes.REVIEW_NEED_REVIEW_DOCUMENT_SUCCESS;
  document: IKycDocument;
}

export interface IReviewNeedReviewDocumentFailAction extends IBaseAction {
  type: typeof KycActionTypes.REVIEW_NEED_REVIEW_DOCUMENT_FAIL;
  document: IKycDocument;
  error: TAppError;
}

export type TKycNeedReviewAction =
  | IGetKycNeedReviewAction
  | IGetKycNeedReviewSuccessAction
  | IGetKycNeedReviewFailAction
  | IGetKycNeedReviewPreviewAction
  | IGetKycNeedReviewPreviewSuccessAction
  | IGetKycNeedReviewPreviewFailAction
  | IReviewNeedReviewDocumentAction
  | IReviewNeedReviewDocumentSuccessAction
  | IReviewNeedReviewDocumentFailAction;

export interface IKycNeedReviewDocument {
  document: IKycDocument;
  preview?: IKycDocumentPreview;
  edit?: IState;
}
export interface IKycNeedReviewState extends IBaseState {
  documents?: ICursorElements<IState<IKycNeedReviewDocument>>;
}
export interface IKycDocumentReviewModalProps extends IBaseModalProps {
  document: TComputedKycDocument;
  isFromNeedReview?: boolean;
  user?: IUser;
}
